/**
 * @generated SignedSource<<0405c266912137485be5919420265dbb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TaskMigrateDialog_coursesQuery$variables = {};
export type TaskMigrateDialog_coursesQuery$data = {
  readonly courses: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
};
export type TaskMigrateDialog_coursesQuery = {
  response: TaskMigrateDialog_coursesQuery$data;
  variables: TaskMigrateDialog_coursesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CourseConnection",
    "kind": "LinkedField",
    "name": "courses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CourseEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Course",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskMigrateDialog_coursesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TaskMigrateDialog_coursesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5fc812626334e596deeba0fcbdf28649",
    "id": null,
    "metadata": {},
    "name": "TaskMigrateDialog_coursesQuery",
    "operationKind": "query",
    "text": "query TaskMigrateDialog_coursesQuery {\n  courses {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f9530daca48bfed072e43069e7e7308a";

export default node;
